<template>
  <div class="index-breadcrumb-warp" v-if="NavList.length>0">
    <div class="index-breadcroum-nav">
      <div class="left">
        <!-- @click="visiblelable = !visiblelable" -->
        <span class="tag" >
          <span>{{NavList[NavList.length-1].catalogName}}</span>
           <!-- <img class="img1" width="20px" height="20px" src="@/assets/image/xisa.png" /> -->
        </span>
        <!-- <div class="showItem" v-if="visiblelable" >
          <div class="item item_t" catchtap="showTypeFun"  v-for="(item,index) in NavList" :key="index" @click="navClickFun(item,index)" >
            {{item.catalogName || item.atlasCategoryName}}
          </div>	
        </div> -->
      </div>
      <div class="right">
        <img :src="showImg" alt @click="showItemFun" />
        <transition name="van-fade">
          <div class="showItem" v-show="visible">
            <div class="item" @click="checkItemFun('m1')">
              <img src="../../assets/atlas/m1.png" alt />
              一行四列
            </div>
            <div class="item" @click="checkItemFun('m2')">
              <img src="../../assets/atlas/m2.png" alt />
              一行两列
            </div>
            <div class="item" @click="checkItemFun('m3')">
              <img src="../../assets/atlas/m3.png" alt />
              列表
            </div>
          </div>
        </transition>
      </div>
    </div>
    <!-- <div class="index-breadcroum-tops" v-show="$route.query.type!='brand'">查看更多优惠商品可点击上方目录~</div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      img1: require("@/assets/atlas/1.png"),
      img2: require("@/assets/atlas/2.png"),
      img3: require("@/assets/atlas/3.png"),
      showImg: require("@/assets/atlas/1.png"),
      // navList:[{id:1,name:'全部',type:true},{id:1,name:'小白鞋组合',type:false}],
      visiblelable: false
    };
  },
  props: {
    NavList: {
      default: [],
      type: Array
    },
    barnchId:{
      default:''
    },
    barnchName:{
       default:'',
      type:String
    }
  },
  methods: {
    showItemFun() {
      this.visible = !this.visible;
    },
    checkItemFun(type) {
      if (type == "m1") {
        this.showImg = this.img1;
      } else if (type == "m2") {
        this.showImg = this.img2;
      } else {
        this.showImg = this.img3;
      }
      this.$emit("showTypeFun", type);
      this.showItemFun();
    },
    navClickFun(item, index) {
      this.visiblelable = !this.visiblelable;
      let parmes = {
        item: item,
        index: index
      };
      this.$emit("showNavfun", parmes);
      let p={
        userID_var:'00000',
        userName_var:'',
        functionName_var:'根目录',
        imageSet_var:item.id,
        storeID_var:this.$route.query.barnchId,
        storeName_var:this.barnchName
      }
      if(localStorage.getItem('userInfo')){
        let userInfo = JSON.parse(localStorage.getItem('userInfo'));
        p.userID_var=userInfo.userId+'';
        p.userName_var = userInfo.nickName;
      };
      gio('track','userImageProductSetEnterAll_var',p)
    }
  }
};
</script>
<style lang="less" scoped>
.index-breadcrumb-warp {
  padding: 0 30px 0 30px;
  background-color: #fff;
  height: 80px;
  border-top:1PX solid #F2F2F2;
  .index-breadcroum-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      flex: 1;
      display: flex;
      align-items: center;
      position: relative;
      color: #333333;
      line-height: 80px;
      .showItem{
        width: 173px;
        position: absolute;
        background-color: #666;
        font-size: 26px;
        left: -30px;
        top: 70px;
        color: #fff;
        border-radius: 10px;
        padding:20px;
        z-index: 10;
        text-align: center;
        .item_t{
          padding: 10px 0;
        }
      }
      .tag {
        // background-color: #F8D541;
        // border-radius: 50px;
        // padding: 5px;
        // box-sizing: border-box;
        font-size: 24px;
        color: #333333;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        // padding-left: 18px;
      }
    }
    .right {
      width: 50px;
      position: relative;
      .showItem {
        width: 200px;
        position: absolute;
        top: 80px;
        right: 0;
        background-color: #666;
        font-size: 26px;
        color: #fff;
        border-radius: 20px;
        padding: 30px 0px 10px 20px;
        z-index: 10;
        img {
          width: 44px;
          height: 44px;
          object-fit: cover;
          vertical-align: -webkit-baseline-middle;
          padding-bottom: 20px;
        }
      }
    }
  }
  .index-breadcroum-tops {
    font-size: 24px;
    color: #f8a651;
    padding: 11px 0;
    height: 48px;
    line-height: 48px;
    border-top: 1px solid #f2f2f2;
  }
}
</style>